import React, { useState, useEffect } from 'react';
import './advancepayment.css';
import { useLocation, useNavigate } from "react-router-dom";
import Dashheader from '../../Dashheader/Dashheader';
import { Input, Form, Row, Col, Button, message } from 'antd';
import api from "./../../../../api.js";
import { useToasts } from "react-toast-notifications";
import Loading from '../../../../utilis/Loading.js';
import { Select } from 'antd';
import utilis from "../../../../utilis";
import { Radio, Space } from 'antd';
import dayjs from 'dayjs'; // --- Narendra T: Ensure dayjs is imported
const { Option } = Select;


const AdvancePayment = () => {
  let navigate = useNavigate();
  const [bookedFlats, setBookedFlats] = useState([]);
  const [loading, setLoading] = useState(false);
  const { addToast } = useToasts();
  const [paymentData, setPaymentData] = useState({
    towerName: "",
    unitType: "",
    flatNo: "",
    block: "",
    floor: "",
    bedrooms: "",
    withoutGst: "",
    gst: "",
    gstAmount: "",
    totalAmount: "",
    paymentFor: "",
    paymentMode: "",
    referenceNo: "",
    transactionFor: "",
     schemeId: "", // Add this line
     paidOn: dayjs().format('YYYY-MM-DD'),
    // CGST: 0,
    // SGST: 0,
    // UGST: 0,
    // IGST: 0,
  });
  

  // State for UI display only - not sent to backend
  const [gstBreakdown, setGstBreakdown] = useState({
    CGST: 0,
    SGST: 0,
    UGST: 0,
    IGST: 0,
  });

 const getSchemeBalance = (bookedFlatId, schemeId) => {
    if (!bookedFlatId || !schemeId) return null;
    const flat = bookedFlats.find((f) => f._id === bookedFlatId);
    if (!flat || !flat.phaseDetails) return null;
    for (const phase of flat.phaseDetails) {
      const scheme = (phase.scheme || []).find((s) => s._id === schemeId);
      if (scheme) return Number(scheme.balanceAmount) || 0;
    }
    return null;
  };
// ...existing code...

 const handleChange = (e) => {
  const { name, value } = e.target;

  setPaymentData((prevData) => {
    // If user is entering the withoutGst amount, validate against selected scheme balance
    if (name === 'withoutGst') {
      const enteredAmount = parseFloat(value) || 0;
      const schemeBalance = getSchemeBalance(prevData.bookedFlatId, prevData.schemeId);

      if (schemeBalance !== null && enteredAmount > schemeBalance) {
        addToast(`Entered amount exceeds selected schedule balance (${schemeBalance}).`, { appearance: 'error', autoDismiss: true });
        // do not accept the change
        return prevData;
      }
    }

    const updatedData = {
      ...prevData,
      [name]: value,
    };

    const paymentMode = name === 'paymentMode' ? value : prevData.paymentMode;
    const withoutGst = parseFloat(name === 'withoutGst' ? value : updatedData.withoutGst) || 0;
    
    // Use the gst state value or the updated value if GST is being changed
    const gstPercentage = name === 'gst' ? parseFloat(value) : parseFloat(gst) || 0;

    if (paymentMode === 'CASH' || paymentMode === 'TDS') {
      updatedData.gstAmount = 0;
      updatedData.totalAmount = withoutGst ? Math.round(withoutGst) : 0;
      setGstBreakdown({
        CGST: 0,
        SGST: 0,
        IGST: 0,
        UGST: 0,
      });
    } else {
      const gstAmount = (withoutGst * gstPercentage) / 100;
      const totalAmount = withoutGst + gstAmount;
      updatedData.gstAmount = Math.round(gstAmount);
      updatedData.totalAmount = Math.round(totalAmount);

      const stateGstCode = getCustomerGstdetails?.stateGstCode;
      if (stateGstCode === 36) {
        setGstBreakdown({
          CGST: gstAmount / 2,
          SGST: gstAmount / 2,
          IGST: 0,
          UGST: 0,
        });
      } else {
        setGstBreakdown({
          CGST: 0,
          SGST: 0,
          IGST: gstAmount,
          UGST: 0,
        });
      }
    }

    // Always set the GST percentage in paymentData
    updatedData.gst = gstPercentage;

    return updatedData;
  });
};


  const [userDetails, setuserDetails] = useState([]);
  const GetUserDetails = async () => {
    try {
      let response = await api.userdetailsforbooking();
      setuserDetails(response.data.data);
      if(response.status === 401){
        console.log("Session Expired! Redirecting to Login.");
        localStorage.removeItem(utilis.string.localStorage.sessionId);
        localStorage.removeItem(utilis.string.localStorage.userData);
        navigate('/');
      }

      console.log("Fetched userdetails:", response.data.data);
    } catch (error) {
      console.error("Error userdetails:", error);
    }
  };

  useEffect(() => {
    GetUserDetails();
  }, []);

  const [getCustomerGstdetails, setgetCustomerGstdetails] = useState([]);

  const GetCustomerGstdetails = async (stateId) => {
    if (!stateId) return;
    try {
      let response = await api.getGstDetails(stateId);
      setgetCustomerGstdetails(response.data.data);
      console.log(response.data.data, 'getCustomerGstdetails');

      const gstAmount = Number(paymentData.gstAmount) || 0;
      if (response.data.data && response.data.data.stateGstCode === 36) {
        setGstBreakdown({
          CGST: gstAmount / 2,
          SGST: gstAmount / 2,
          IGST: 0,
          UGST: 0,
        });
      } else {
        setGstBreakdown({
          CGST: 0,
          SGST: 0,
          IGST: gstAmount,
          UGST: 0,
        });
      }
    } catch (error) {
      console.error("getCustomerGstdetails", error);
    }
  };

const handleSearch = async () => {
  // Change this line:
  const phone = String(paymentData.phoneNumber || "").trim(); // Explicitly convert to string and then trim

  // if (phone.length !== 10) {
  //   message.error("Please enter a valid 10-digit phone number.");
  //   return;
  // }

  // ... rest of your handleSearch function remains the same
  setBookedFlats([]);
  setPaymentData((prev) => ({
    towerName: "",
    unitType: "",
    flatNo: "",
    block: "",
    floor: "",
    bedrooms: "",
    withoutGst: "",
    gst: "",
    gstAmount: "",
    totalAmount: "",
    paymentFor: "",
    paymentMode: "",
    referenceNo: "",
    phoneNumber: phone, // explicitly set current phone
    username: "",
    aadharNumber: "",
    flatId: "",
    blockId: "",
    towerId: "",
    projectId: "",
    companyId: "",
    userId: "",
    bookedFlatId: "",
    createdBy: "",
    transactionFor: "",
    schemeId: "",
    paidOn: dayjs().format('YYYY-MM-DD'),
  }));

  try {
    const response = await api.userdetailsforbooking(phone);

    if (response.status === 200 && response.data.data.result?.length > 0) {
      const userDetails = response.data.data.result[0];

      setPaymentData((prevData) => ({
        ...prevData,
        username: userDetails.name || "",
        aadharNumber: userDetails.govtIdProof?.[0] || "",
        phoneNumber: userDetails.phoneNumber || "",
        userId: userDetails._id || "",
      }));

      if (userDetails.stateId) {
        await GetCustomerGstdetails(userDetails.stateId);
      }

      const bookedFlatDetails = response.data.data.bookedFlatDetails;

      if (bookedFlatDetails && bookedFlatDetails.length > 0) {
        const uniqueFlats = [...new Map(bookedFlatDetails.map(flat => [flat.flatNo, flat])).values()];
        setBookedFlats(uniqueFlats);

        const firstFlat = uniqueFlats[0];
        let firstSchemeId = "";
        if (firstFlat.phaseDetails?.[0]?.scheme?.[0]?._id) {
          firstSchemeId = firstFlat.phaseDetails[0].scheme[0]._id;
        }

        setPaymentData((prevData) => ({
          ...prevData,
          towerName: firstFlat.towerName || "",
          unitType: firstFlat.unitType || "",
          flatNo: firstFlat.flatNo || "",
          block: firstFlat.block || "",
          floor: firstFlat.floor || "",
          bedrooms: firstFlat.bedrooms || "",
          gst: firstFlat.gst || "",
          paymentFor: firstFlat.flatNo || "",
          flatId: firstFlat.flatId || "",
          blockId: firstFlat.blockId || "",
          towerId: firstFlat.towerId || "",
          projectId: firstFlat.projectId || "",
          companyId: firstFlat.companyId || "",
          bookedFlatId: firstFlat._id || "",
          createdBy: firstFlat.createdBy || "",
          transactionFor: firstFlat.unitType || "",
          schemeId: firstSchemeId,
        }));
      }

      message.success("User details fetched successfully.");

    } else {
      setBookedFlats([]);
      message.error("No user details found for this phone number.");
    }

  } catch (error) {
    console.error("Error fetching user details:", error);
    message.error("Failed to fetch user details. Please try again.");
  }
};





  const [gst, setGst] = useState("");

  const GetGst = async () => {
    try {
      let response = await api.getGst();
      console.log("Full GST API Response:", response);

      if (response.data && response.data.data && response.data.data.length > 0 && response.data.data[0].gst !== undefined) {
        setGst(response.data.data[0].gst);
      } else {
        console.error("GST data not found in API response.");
        console.log("Response structure:", response.data);
        setGst(0);
      }
    } catch (error) {
      console.error("Error fetching GST:", error);
    }
  };

  useEffect(() => {
    console.log("GST State Updated:", gst);
  }, [gst]);

  useEffect(() => {
    GetGst();
  }, []);

  const handleFlatSelection = (flatNo) => {
    const selectedFlat = bookedFlats.find((flat) => flat.flatNo === flatNo);
    if (selectedFlat) {
        // Get first scheme ID for the selected flat
    let firstSchemeId = "";
    if (selectedFlat.phaseDetails && selectedFlat.phaseDetails.length > 0) {
      const firstPhase = selectedFlat.phaseDetails[0];
      if (firstPhase.scheme && firstPhase.scheme.length > 0) {
        firstSchemeId = firstPhase.scheme[0]._id;
      }
    }
      setPaymentData((prevData) => ({
        ...prevData,
        towerName: selectedFlat.towerName || "",
        unitType: selectedFlat.unitType || "",
        flatNo: selectedFlat.flatNo || "",
        block: selectedFlat.block || "",
        floor: selectedFlat.floor || "",
        bedrooms: selectedFlat.bedrooms || "",
        gst: selectedFlat.gst || "",
        paymentFor: selectedFlat.flatNo || "",
        flatId: selectedFlat.flatId || "",
        blockId: selectedFlat.blockId || "",
        towerId: selectedFlat.towerId || "",
        projectId: selectedFlat.projectId || "",
        companyId: selectedFlat.companyId || "",
        userId: selectedFlat.userId || "",
        bookedFlatId: selectedFlat._id || "",
        createdBy: selectedFlat.createdBy || "",
        transactionFor: selectedFlat.unitType || "",
           schemeId: firstSchemeId, // Automatically set first scheme ID
      }));
    }
  };

 
 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  console.log("Total Amount:", paymentData.totalAmount);
  try {
    // Exclude GST breakdown fields from payload - they're UI only
    const { username, phoneNumber, aadharNumber, ...payload } = paymentData;

    payload.totalAmount = parseFloat(payload.totalAmount) || 0;
    payload.withoutGst = parseFloat(payload.withoutGst) || 0;
    payload.gstAmount = parseFloat(payload.gstAmount) || 0;
    
    // Ensure GST percentage is included from the gst state
    payload.gst = parseFloat(gst) || 0;

    // Add paidOn and createdOn with current date and time
    const currentTime = new Date().toISOString();
    // payload.paidOn = currentTime;
    payload.createdOn = currentTime;
    payload.paidOn = payload.paidOn ? new Date(payload.paidOn).toISOString() : null;  

    // Validate against selected scheme balance before sending
    const schemeBalance = getSchemeBalance(payload.bookedFlatId, payload.schemeId);
    if (schemeBalance !== null && payload.withoutGst > schemeBalance) {
      addToast(`Entered amount exceeds selected schedule balance (${schemeBalance}).`, { appearance: 'error', autoDismiss: true });
      setLoading(false);
      return;
    }

    console.log("Payload being sent to backendDDDDDDDDDDDDDDDDDDDDDD:", payload);

    const response = await api.advancePayment(payload);
    if(response.status === 401){
      console.log("Session Expired! Redirecting to Login.");
      localStorage.removeItem(utilis.string.localStorage.sessionId);
      localStorage.removeItem(utilis.string.localStorage.userData);
      navigate('/');
    }

    if (response.status === 200) {
      addToast(response.data?.message || "Payment details submitted successfully", {
        appearance: "success",
        autoDismiss: true,
      });

      setPaymentData({
        towerName: "",
        unitType: "",
        flatNo: "",
        block: "",
        floor: "",
        bedrooms: "",
        withoutGst: "",
        gst: "",
        gstAmount: "",
        totalAmount: "",
        paymentFor: "",
        paymentMode: "",
        referenceNo: "",
        phoneNumber: "",
        flatId: "",
        blockId: "",
        towerId: "",
        projectId: "",
        companyId: "",
        userId: "",
        bookedFlatId: "",
        createdBy: "",
        transactionFor: "",
        schemeId: "",
           paidOn: dayjs().format('YYYY-MM-DD'), 
      });
      
      // Reset GST breakdown display
      setGstBreakdown({
        CGST: 0,
        SGST: 0,
        UGST: 0,
        IGST: 0,
      });
    } else {
      addToast(response.data?.message || "Something went wrong!", {
        appearance: "error",
        autoDismiss: true,
      });
    }
  } catch (error) {
    message.error("Failed to submit payment details. Please try again later.");
  } finally {
    setLoading(false);
  }
};


  return (
    <>
      <Dashheader />
      {loading ? (
        <Loading/>
      ) : (
        <div className="advancepayment">
          <div className="advancepayment__header">
            <h2>Enter Payment Details</h2>
          </div>
       
          <div className="advancepayment__phone">
            <Form.Item label="Enter Customer Phone Number">
              <div className="advancepayment__phone-container">
                <Input
                  type="text"
                  name="phoneNumber"
                  value={paymentData.phoneNumber}
                  onChange={(e) =>
                    setPaymentData({ ...paymentData, phoneNumber: e.target.value })
                  }
                  placeholder="Enter Phone Number"
                  className="advancepayment__input"
                />
                <Button
                  type="primary"
                  className="advancepayment__search-button"
                  onClick={handleSearch}
                >
                  Search
                </Button>
              </div>
            </Form.Item>
          </div>

          <Form layout="vertical" onSubmitCapture={handleSubmit}>
            <>
              <Row gutter={16}>
                 <Col span={8}>
                  <Form.Item label="Paid On">
                    <Input
                      type="date"
                      name="paidOn"
                      value={paymentData.paidOn}
                      onChange={(e) => setPaymentData({ ...paymentData, paidOn: e.target.value })}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Payment For">
                    <Select
                      value={paymentData.paymentFor}
                      onChange={(flatNo) => handleFlatSelection(flatNo)}
                      placeholder="Select Flat No"
                    >
                      {bookedFlats.map((flat) => (
                        <Option key={flat.flatNo} value={flat.flatNo}>
                          {flat.flatNo}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="User Name">
                    <Input
                      type="text"
                      readOnly
                      name="username"
                      value={paymentData.username}
                      onChange={handleChange}
                      placeholder="Enter user Name"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Aadhar Number">
                    <Input
                      type="text"
                      name="aadharNumber"
                      readOnly
                      value={paymentData.aadharNumber}
                      onChange={handleChange}
                      placeholder="Enter aadhar Number"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Tower Name">
                    <Input
                      type="text"
                      name="towerName"
                      readOnly
                      value={paymentData.towerName}
                      onChange={handleChange}
                      placeholder="Enter Tower Name"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Unit Type">
                    <Input
                      type="text"
                      name="unitType"
                      readOnly
                      value={paymentData.unitType}
                      onChange={handleChange}
                      placeholder="Enter Unit Type"
                    />
                  </Form.Item>
                </Col>
               
              </Row>
              <Row gutter={16}>
                 <Col span={8}>
                  <Form.Item label="Flat No">
                    <Input
                      type="text"
                      name="flatNo"
                      readOnly
                      value={paymentData.flatNo}
                      onChange={handleChange}
                      placeholder="Enter Flat No"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Transaction For">
                    <Input
                      type="text"
                      name="transactionFor"
                      readOnly
                      value={paymentData.transactionFor}
                      onChange={handleChange}
                      placeholder="Transaction For"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Block">
                    <Input
                      type="text"
                      name="block"
                      readOnly
                      value={paymentData.block}
                      onChange={handleChange}
                      placeholder="Enter Block"
                    />
                  </Form.Item>
                </Col>
                
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="Floor">
                    <Input
                      type="number"
                      name="floor"
                      readOnly
                      value={paymentData.floor}
                      onChange={handleChange}
                      placeholder="Enter Floor"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Amount (Without GST)">
                    <Input
                      type="number"
                      name="withoutGst"
                      value={paymentData.withoutGst}
                      onChange={handleChange}
                      placeholder="Enter Amount Without GST"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="bedrooms">
                    <Input
                      name="bedrooms"
                      readOnly
                      value={paymentData.bedrooms}
                      onChange={handleChange}
                      placeholder="Enter bedrooms"
                    />
                  </Form.Item>
                </Col>
            

              </Row>
              <Row gutter={16}>
                    <Col span={8}>
  <Form.Item label="GST Percentage">
    <Input
      type="number"
      name="gst"
      value={gst}
      readOnly
      onChange={(e) => {
        setGst(e.target.value);
        setPaymentData(prev => ({ ...prev, gst: e.target.value }));
      }}
      placeholder="GST Percentage"
    />
  </Form.Item>
</Col>
                {paymentData.paymentMode !== "CASH" && paymentData.paymentMode !== "TDS" && (
                  <Col span={8}>
                    <Form.Item label="GST Amount">
                      <Input
                        type="number"
                        name="gstAmount"
                        value={paymentData.gstAmount}
                        readOnly
                        placeholder="GST Amount"
                      />
                    </Form.Item>
                  </Col>
                )}
                {(paymentData.paymentMode === "CASH" || paymentData.paymentMode === "TDS") &&  (
                  <Col span={8}>
                    <Form.Item label="GST Amount">
                      <Input
                        type="number"
                        name="gstAmount"
                        value={0}
                        readOnly
                        placeholder="GST Amount"
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col span={8}>
                  <Form.Item label="CGST (%)">
                    <Input
                      type="number"
                      name="CGST"
                      value={gstBreakdown.CGST}
                      readOnly
                      placeholder="CGST"
                    />
                  </Form.Item>
                </Col>
               
              </Row>
              <Row gutter={16}>
                 <Col span={8}>
                  <Form.Item label="SGST (%)">
                    <Input
                      type="number"
                      name="SGST"
                      value={gstBreakdown.SGST}
                      readOnly
                      placeholder="SGST"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="IGST (%)">
                    <Input
                      type="number"
                      name="IGST"
                      value={gstBreakdown.IGST}
                      readOnly
                      placeholder="IGST"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Total Amount">
                    <Input
                      type="number"
                      name="totalAmount"
                      value={paymentData.totalAmount}
                      readOnly
                      placeholder="Total Amount"
                    />
                  </Form.Item>
                </Col>
                
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label="Select Payment Mode">
                    <Select
                      name="paymentMode"
                      value={paymentData.paymentMode}
                      onChange={(value) => handleChange({ target: { name: 'paymentMode', value } })}
                      placeholder="Select Payment Mode"
                    >
                      <Option value="" disabled>Select Payment Mode</Option>
                      <Option value="CHEQUE">CHEQUE</Option>
                      <Option value="CASH">CASH</Option>
                      <Option value="BANK_TRANSFER">BANK_TRANSFER</Option>
                      <Option value="TDS">TDS</Option> 
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Reference No">
                    <Input
                      type="text"
                      name="referenceNo"
                      value={paymentData.referenceNo}
                      onChange={handleChange}
                      placeholder="Enter Reference No"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </>

            <Row>
              <Col span={24} style={{ textAlign: 'center' }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="advancepayment__submit"
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      )}
    </>
  );
};

export default AdvancePayment;
